import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var isOdd = index => {
  return index === 0 || index % 2 === 1;
};
export var getFormWidgetStyles = (isSmallScreen, props) => {
  var heading = props.heading;
  var _tokens$spacing = tokens.spacing,
    SPACING_8 = _tokens$spacing.SPACING_8,
    SPACING_16 = _tokens$spacing.SPACING_16,
    SPACING_20 = _tokens$spacing.SPACING_20,
    SPACING_24 = _tokens$spacing.SPACING_24;
  var topSpacing = isSmallScreen ? SPACING_16 : SPACING_20;
  return StyleSheet.create({
    container: Object.assign({
      width: '100%'
    }, !heading && {
      marginTop: -topSpacing
    }),
    badge: {
      marginRight: SPACING_8
    },
    reviewsTitle: {
      marginVertical: SPACING_20
    },
    reviewContainer: {
      marginTop: SPACING_20
    },
    formContainer: {
      width: '100%',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'flex-start'
    },
    formItem: {
      width: '100%'
    },
    formItemInput: {
      width: isSmallScreen ? '100%' : '50%'
    },
    formItemRightSpace: {
      paddingRight: isSmallScreen ? 0 : SPACING_24
    },
    safeTopSpacing: {
      marginTop: topSpacing
    },
    zIndex2: {
      zIndex: 9
    }
  });
};